import React from 'react';
import { ContentWrapper, ImgWrapper, TextWrapper, Wrapper } from './styled';
import { Button } from 'ds/components/button';
import { createPortal } from 'utils/universalPortal';
import { COOKIE_ROOT } from 'consts/rootNodes';
import useAnchorLink from 'hooks/useAnchorLink';
import { Link } from 'ds/components/link';
import { connect } from 'react-redux';
import { isCookieModalOpenSelector } from 'store/state/app/selectors';
import { State } from 'store/state';
import { setCookieConsentModalAction } from 'store/state/app/actions';
import Cookie from 'js-cookie';
import { COOKIE_USER_CONSENT_KEY } from 'store/sagas/cookieWatcher';
import { useLocale } from 'locale';


const USER_TOKEN_TTL_DAYS = 1440;
export const USER_TOKEN_TTL_MS = USER_TOKEN_TTL_DAYS * 24 * 60 * 60 * 1000;

const cookieOpts: Cookie.CookieAttributes = {
  expires: USER_TOKEN_TTL_DAYS, // days from now
};

const CookiesPopupBase: React.FC<{ isOpen: boolean; setCookieModal: (isOpen: boolean) => void }> = ({ isOpen, setCookieModal }) => {
  const { t } = useLocale();

  const href = useAnchorLink('/etc/terms');

  const linkText = t('termsAndConditions.preview.link');
  const link = <Link href={href} target="_blank" style={{ fontSize: 17 }}>{linkText}</Link>;
  const dot = `.`;
  const text = t('cookie.modal.text');
  const fullText = (
    <>
      {text}
      {link}
      {dot}
    </>
  );

  const handleSubmit = () => {
    setCookieModal(false);
    Cookie.set(COOKIE_USER_CONSENT_KEY, 'true', cookieOpts);
  };

  if (!isOpen) return null;

  const c = (
    <Wrapper>
      <ContentWrapper>
        <ImgWrapper>🍪</ImgWrapper>
        <TextWrapper>{fullText}</TextWrapper>
        <Button size="extraLarge" onClick={handleSubmit}>{t('dealAffiliationPopup.mobile.close')}</Button>
      </ContentWrapper>
    </Wrapper>
  );

  return (
    createPortal(
      c,
      COOKIE_ROOT
    )
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isCookieModalOpenSelector(state),
});

export const CookiesPopup = connect(mapStateToProps, { setCookieModal: setCookieConsentModalAction })(CookiesPopupBase);
